module.exports = __webpack_public_path__ + "img/left-lightning10.5f76d40b.png";